import moment from 'moment'

export const isoLocalDatetimeFormat = 'YYYY-MM-DDTHH:mm:ss'

export const displayDateTimeFormat = 'DD-MM-YYYY HH:mm'

export const zonedDateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ'

export function toDisplayDateTime (isoDateTimeStr) {
  return moment(isoDateTimeStr).format(displayDateTimeFormat)
}

export function toISOOffsetLocalDateTime (displayDateTimeStr, timeZone) {
  return moment(displayDateTimeStr, displayDateTimeFormat, true).utcOffset(timeZone)
}

export function momentToISOLocalDateTime (moment) {
  return moment.format(isoLocalDatetimeFormat)
}

export function momentToISOZonedDateTime (moment) {
  return moment.format(zonedDateTimeFormat)
}

export function momentToISOLocalDate (moment) {
  return moment.format('YYYY-MM-DD')
}

export function momentToISOLocalTime (moment) {
  return moment.format('HH:mm')
}

export function parseMomentFromLocalDateTimeField (str) {
  return moment(str, displayDateTimeFormat, true)
}

export function parseMomentFromLocalDateAndLocalTimeFields (localDateStr, localTimeStr) {
  return moment(`${localDateStr} ${localTimeStr}`)
}

export function parseFormDisplayedDateFormatWithZone (date, time, timeZone) {
  return moment(parseMomentFromLocalDateAndLocalTimeFields(date, time), displayDateTimeFormat)
    .utcOffset(timeZone)
    .format(zonedDateTimeFormat)
}
